export default "__VITE_ASSET__CdFaZCGK__"